import httpService from "./httpService";

const DownloadImageApi = {
  
  getDownloadedImageul: (id) => httpService.get(`getMediaSignedUrl/?media_id=${id||""}`),
  getDownloadedImageUrlByName: (fileName) =>
    httpService.get(`getMediaSignedUrl/?file_name=${encodeURIComponent(fileName || "")}`),
   
};

export default DownloadImageApi;
